// extracted by mini-css-extract-plugin
export default {"serviceBox":"ServiceBox_serviceBox__IOpl1","content":"ServiceBox_content__M-JAW"};